<template>
    <main class="site-content">
        <el-card style="min-height: 100%;">
            <keep-alive>
                <router-view />
            </keep-alive>   
        </el-card>
    </main>
</template>

<script>
    import { isURL } from '@/utils/validate'
    export default {
        data () {
            return {
              mainTabs:[]
            }
        },
        methods: {
            // tabs, 选中tab
            selectedTabHandle (tab) {
                tab = this.mainTabs.filter(item => item.name === tab.name);
                if (tab.length >= 1) {
                    this.$router.push({ name: tab[0].name, query: tab[0].query, params: tab[0].params })
                }
            },
            // tabs, 删除tab
            removeTabHandle (tabName) {
                this.mainTabs = this.mainTabs.filter(item => item.name !== tabName);
                if (this.mainTabs.length >= 1) {

                } else {
                    this.menuActiveName = '';
                    this.$router.push({ name: 'home' })
                }
            },
            // tabs, 关闭当前
            tabsCloseCurrentHandle () {

            },
            // tabs, 关闭其它
            tabsCloseOtherHandle () {

            },
            // tabs, 关闭全部
            tabsCloseAllHandle () {
                this.mainTabs = [];
                this.menuActiveName = '';
                this.$router.push({ name: 'home' })
            },
            // tabs, 刷新当前
            tabsRefreshCurrentHandle () {
                let tab = this.$route;
                this.removeTabHandle(tab.name);
                this.$nextTick(() => {
                    this.$router.push({ name: tab.name, query: tab.query, params: tab.params })
                })
            }
        }
    }
</script>



<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/main-content.vue